import React, { createContext, useState, useContext, useEffect } from 'react';
import { STORAGE_KEYS } from '../config/constants';

const UIContext = createContext(null);

export const UIProvider = ({ children }) => {
  const [modals, setModals] = useState({
    login: false,
    loginWaiting: false,
    forgotPassword: false,
    createAccount: false,
    settings: false,
    report: false,
  });

  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    const stored = localStorage.getItem(STORAGE_KEYS.SIDEBAR_COLLAPSED);
    return stored === 'true';
  });

  const [aiAnalystOpen, setAiAnalystOpen] = useState(false);
  const [centerMenuCollapsed, setCenterMenuCollapsed] = useState(false);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEYS.SIDEBAR_COLLAPSED, sidebarCollapsed.toString());
  }, [sidebarCollapsed]);

  const openModal = (modalName) => {
    setModals(prev => ({ ...prev, [modalName]: true }));
  };

  const closeModal = (modalName) => {
    setModals(prev => ({ ...prev, [modalName]: false }));
  };

  const closeAllModals = () => {
    setModals({
      login: false,
      loginWaiting: false,
      forgotPassword: false,
      createAccount: false,
      settings: false,
      report: false,
    });
  };

  const toggleSidebar = () => {
    setSidebarCollapsed(prev => !prev);
  };

  const openAIAnalyst = () => {
    setAiAnalystOpen(true);
  };

  const closeAIAnalyst = () => {
    setAiAnalystOpen(false);
  };

  const toggleCenterMenu = () => {
    setCenterMenuCollapsed(prev => !prev);
  };

  return (
    <UIContext.Provider value={{
      modals,
      openModal,
      closeModal,
      closeAllModals,
      sidebarCollapsed,
      toggleSidebar,
      aiAnalystOpen,
      openAIAnalyst,
      closeAIAnalyst,
      centerMenuCollapsed,
      toggleCenterMenu
    }}>
      {children}
    </UIContext.Provider>
  );
};

export const useUI = () => {
  const context = useContext(UIContext);
  if (!context) {
    throw new Error('useUI must be used within UIProvider');
  }
  return context;
};

